export default {"src":"/_next/static/media/map-with-pin.14ec1d45.svg","height":448,"width":500};